import postalCodeRegex from '@eneco/common/validation/postalCodeRegex';
import * as yup from 'yup';


export const canRegisterAddressSchema = (isSuffixRequired: boolean) => {
  return yup.object({
    postalCode: yup.string().required('postalCodeRequired').matches(postalCodeRegex, { message: 'postalCodeInvalid' }),
    houseNumber: yup
      .string()
      .required('houseNumberRequired')
      .test({
        message: 'houseNumberRequired',
        test: value => !!value && +value > 0,
      }),
    ...(isSuffixRequired && { houseNumberSuffix: yup.string().required('houseNumberSuffixInvalid') }),
  });
};
